<!--  -->
<template>
  <div class="container">
    <div class="home" v-show="type == 1">
      <div class="top-box">
        <div class="flexrbc">
          <div class="flexr0c">
            <div class="title-label"></div>
            <div class="title">我的通知</div>
          </div>
          <div class="flexrbc">
            <Input v-model="searchText" placeholder="请输入您要搜索的内容" style="width: auto" @on-blur="getList(1)" @on-enter="getList(1)">
            <Icon type="ios-search" slot="suffix" />
            </Input>
            <div class="addOrg flexrcc" @click="model2Show">
              <div class="btn">删除</div>
            </div>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="content-item" v-if="list.length != 0">
          <div class="noticeList">
            <div class="list-item flexrbc" v-for="(item, index) in list" :key="index">
              <div class="flexr0c">
                <Checkbox v-model="item.choosed"></Checkbox>
                <div class="title">{{ item.theme }}</div>
              </div>
              <div class="flexr0c">
                <div class="time">{{ item.addTime }}</div>
                <div class="split-line"></div>
                <div class="status">{{ item.read }}</div>
                <div class="look-detail" @click="lookDetail(item.id, index)" :data-id="item.id">查看详情</div>
              </div>
            </div>
          </div>
          <div style="float: right; margin-bottom: 20px">
            <Page :total="total" @on-change="changePage" show-total show-elevator />
          </div>
        </div>
        <div class="no-data-box flexccc" v-if="list.length == 0">
          <img src="../../assets/imgs/home/no-data.png" alt="" />
          <div class="no-data-txt">暂无数据</div>
        </div>
      </div>
    </div>
    <div class="second-page" v-show="type == 2">
      <div class="top flexr0c">
        <img class="addr" src="../../assets/imgs/home/location.png" alt="" />
        <div class="title" @click="manage">我的通知</div>
        <img class="arrow" src="../../assets/imgs/home/rightarrow.png" alt="" />
        <div class="title">通知详情</div>
      </div>
      <div class="detail-content">
        <div class="title">{{ detail.theme }}</div>
        <div class="time">通知日期：{{ detail.addTime }}</div>
        <div class="content-txt">{{ detail.content }}</div>
        <div class="table" v-if="enterpriseInfoChange">
          <Table border stripe :columns="tableHead" :data="tableData">
            <template slot-scope="{ row }" slot="beforechangename">
              <div v-if="row.beforechangename&&row.beforechangename.replace(/[^\/]/g, '').length > 2 && /\.(png|jpg|jpeg|gif)$/.test(row.beforechangename)" style="cursor: pointer; color: #2c59c3" @click="gobig(fileUrl + row.beforechangename)">图片</div>
              <div v-else>
                {{ row.beforechangename }}
              </div>
            </template>
            <template slot-scope="{ row }" slot="afterchangename">
              <div v-if="row.afterchangename&&row.afterchangename.replace(/[^\/]/g, '').length > 2 && /\.(png|jpg|jpeg|gif)$/.test(row.beforechangename)" style="cursor: pointer; color: #2c59c3" @click="gobig(fileUrl + row.afterchangename)">图片</div>
              <div v-else>
                {{ row.afterchangename }}
              </div>
            </template>
          </Table>
        </div>
      </div>
    </div>
    <div class="mask" v-if="model2">
      <div v-if="model2" class="pop-box">
        <div class="top flexrcc">
          <div class="title">提示</div>
          <img @click="model2 = false" src="../../assets/imgs/home/close.png" alt />
        </div>
        <div class="content flexccc">确定删除此条通知吗？</div>
        <div class="bottom flexrcc">
          <div class="save" @click="comfirmDel">确定</div>
          <div class="cancel" @click="model2 = false">取消</div>
        </div>
      </div>
    </div>
    <!-- 查看大图 -->
    <vue-viewer ref="myViewer" className="my_class" :visible.sync="isShowBig" :images="bigUrl"></vue-viewer>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import vueViewer from "../../components/bigImg/Viewer.vue";
export default {
  name: "notice",
  components: { vueViewer },
  data() {
    return {
      type: 1,
      model1: false,
      model2: false,
      msg: "",
      pageSize: 12,
      total: 0,
      checkBox: "",
      searchText: "",
      enterpriseInfoChange: false,
      isShowBig: false,
      bigUrl: [],
      fileUrl: '',
      list: [],
      detail: {
        title: "",
        content: "",
      },
      tableHead: [
        {
          title: "类别",
          key: "fieldname",
          //   width: 190,
          resizable: true,
        },
        {
          title: "修改前",
          slot: "beforechangename",
          //   width: 190,
          resizable: true,
        },
        {
          title: "修改后",
          slot: "afterchangename",
          //   width: 190,
          resizable: true,
        },
      ],
      tableData: [],
    };
  },
  computed: {
    ...mapState(["contentType", "notReadCount"]),
  },
  methods: {
    ...mapActions(["getUnread"]),
    changePage(page) {
      this.getList(page);
    },
    gobig: function (url) {
      this.isShowBig = true;
      if (this.bigUrl) {
        this.bigUrl.pop();
      }
      this.bigUrl.push(url);
    },
    goremove: function (i) {
      if (i == 0) {
        this.billForm.front = "";
      } else if (i == 1) {
        this.billForm.back = "";
      }
    },
    model2Show() {
      let arr = [];
      this.list.forEach((ele) => {
        ele.choosed ? arr.push(ele.id) : "";
      });
      if (arr.length > 0) {
        this.model2 = true;
      } else {
        this.$Message["error"]({
          background: true,
          content: "请至少选择一项进行操作！",
        });
      }
    },
    comfirmDel() {
      var that = this;
      var session = JSON.parse(localStorage["session"]);
      var ids = [];
      this.list.forEach((item) => {
        item.choosed ? ids.push(item.id) : ids;
      });
      ids = ids.join(",");
      let data = {
        sessionId: session.sessionId,
        modeCode: "GJmpVT57mA0Z9lznqzkdiwJRXB2lEHq1",
        ids: ids,
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
        } else {
          this.$Message["error"]({
            background: true,
            content: res.msg,
          });
        }
        this.model2 = false;
        this.getList(1);
      });
    },
    manage() {
      this.type = 1;
      this.getUnread();
    },
    lookDetail(id, index) {
      this.type = 2;
      this.list[index].read = "已读";
      var session = JSON.parse(localStorage["session"]);
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: "ffrYqnJXh0xpDxyp9RfOY7G33qUlQEaz",
        id: id,
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.detail = res.data.msgBean;
          if (res.data.changeLogDetailList) {
            this.enterpriseInfoChange = true;
            this.tableData = res.data.changeLogDetailList;
          } else {
            this.enterpriseInfoChange = false;
            this.tableData = [];
          }
        } else {
          this.$Message["error"]({
            background: true,
            content: res.msg,
          });
        }
      });
    },
    getList(index) {
      var id = 1; //测试
      var session = JSON.parse(localStorage["session"]);
      let data = {
        sessionId: session.sessionId,
        modeCode: "g3CdKojCr8oZDLw7TUDdobuXmFD3KUkQ",
        pageIndex: index,
        pageSize: this.pageSize,
        userId: session.userId,
      };
      this.searchText ? (data.keyword = this.searchText) : data;
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          res.data.list.forEach((item) => {
            item.choosed = false;
            item.response == 0 ? (item.read = "未读") : (item.read = "已读");
          });
          this.list = res.data.list;
          this.total = res.data.count;
        } else {
          this.$Message["error"]({
            background: true,
            content: res.msg,
          });
        }
      });
    },
  },
  created() {
    this.fileUrl = localStorage.getItem('fileCommonUrl')
    this.getList(1);
  },
  mounted() { },
};
</script>

<style lang="less" scoped>
.container {
  width: 980px;
  height: 100%;
  text-align: center;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin-left: 20px;
  background: #fff;

  .home {
    .top-box {
      background-image: linear-gradient(180deg, #ffffff 0%, #e8e9ea 100%);
      border-radius: 10px 10px 0 0;
      width: 100%;
      height: 40px;

      /deep/.ivu-input-with-suffix {
        border-radius: 15px;
      }

      & > div {
        height: 100%;
        width: 928px;
        margin: 0 auto;
      }

      .title-label {
        width: 4px;
        height: 14px;
        background: #2c59c3;
      }

      .title {
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #2c59c3;
        letter-spacing: 0.4px;
        margin-left: 6px;
      }

      .addOrg {
        width: 80px;
        height: 30px;
        background-image: linear-gradient(180deg, #f5515f 0%, #9f041b 100%);
        border: 1px solid #d0021b;
        border-radius: 6px;
        cursor: pointer;
        margin-left: 30px;

        &:hover {
          background-image: linear-gradient(180deg, #ff7d89 0%, #b4051f 100%);
          border: 1px solid #af1228;
        }

        img {
          width: 14px;
          height: 14px;
          margin-right: 5px;
        }

        .btn {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0.35px;
        }
      }
    }

    .content {
      background: #fff;
      // min-height: 775px;
      width: 100%;
      // box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.10);
      border-radius: 0 0 10px 10px;

      .content-item {
        width: 928px;
        margin: 0 auto;

        .noticeList {
          margin-bottom: 20px;

          .list-item {
            width: 928px;
            height: 70px;
            background: rgba(224, 229, 240, 0.3);
            margin-top: 18px;
            box-sizing: border-box;
            padding: 0 26px;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #4a4a4a;

            .title {
              margin-left: 6px;
              width: 400px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              text-align: left;
            }

            .split-line {
              width: 1px;
              height: 16px;
              margin: 0 16px;
              background-color: #e5e5e5;
            }

            .look-detail {
              margin-left: 44px;
              cursor: pointer;

              &:hover {
                color: #2c59c3;
              }
            }
          }
        }
      }

      .no-data-box {
        background-color: #fff;
        height: 662px;
        width: 980px;
        box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
        border-radius: 0 0 10px 10px;

        img {
          width: 210px;
          height: 140px;
        }

        .no-data-txt {
          margin-top: 20px;
          font-family: PingFangSC-Medium;
          font-size: 12px;
          color: #9999a8;
          letter-spacing: 0.22px;
        }
      }
    }
  }

  .second-page {
    width: 980px;
    // height: 980px;
    background: #ffffff;
    // box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.10);
    border-radius: 10px;
    position: relative;

    .top {
      .addr {
        width: 14px;
        height: 18px;
        margin: 15px;
        margin-right: 8px;
      }

      .title {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #adb2bc;
        letter-spacing: 0.26px;
        cursor: pointer;
      }

      .arrow {
        width: 7px;
        height: 14px;
        margin: 0 10px;
      }
    }

    .detail-content {
      width: 860px;
      min-height: 775px;
      overflow: hidden;
      text-align: left;
      margin: 10px 52px;

      .title {
        font-family: PingFangSC-Semibold;
        font-size: 20px;
        color: #252a37;
        letter-spacing: 0.36px;
        font-weight: bold;
        margin-bottom: 6px;
      }

      .time {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #9b9b9b;
        letter-spacing: 0.21px;
        margin-bottom: 14px;
      }

      .content-txt {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #252a37;
        letter-spacing: 0.25px;
        text-align: justify;
        line-height: 24px;
        margin-bottom: 15px;
      }
    }
  }

  .mask {
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;

    .pop-box {
      width: 480px;
      height: 282px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;

      .top {
        width: 100%;
        height: 46px;
        background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%);
        border-radius: 10px 10px 0 0;

        .title {
          font-family: PingFangSC-Semibold;
          font-size: 18px;
          color: #ffffff;
          letter-spacing: 0.34px;
        }

        img {
          position: absolute;
          float: right;
          width: 16px;
          height: 16px;
          right: 15px;
          cursor: pointer;
        }
      }

      .content {
        width: 100%;
        height: 186px;
        background-color: #ffffff;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #4a4a4a;
        letter-spacing: 0;
      }

      .bottom {
        // transform: scaleY(-1);
        background: #f5f5f5;
        border-radius: 0 0 10px 10px;
        height: 50px;

        .cancel {
          width: 138px;
          height: 30px;
          line-height: 30px;
          background-image: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.97) 0%,
            rgba(251, 251, 251, 0.98) 37%,
            #f5f5f5 100%
          );
          border: 1px solid #cacaca;
          border-radius: 4px;
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #000000;
          letter-spacing: 0;
          margin-left: 16px;
          text-align: center;
          cursor: pointer;

          &:hover {
            background-image: linear-gradient(
              180deg,
              rgba(255, 255, 255, 0.97) 0%,
              rgba(251, 251, 251, 0.98) 37%,
              #e9e9e9 100%
            );
          }
        }

        .save {
          width: 138px;
          height: 30px;
          line-height: 30px;
          background-image: linear-gradient(180deg, #478ee9 0%, #2255ce 100%);
          border: 1px solid #285ed3;
          border-radius: 4px;
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0;
          text-align: center;
          cursor: pointer;

          &:hover {
            background-image: linear-gradient(180deg, #5295f5 0%, #2559d1 99%);
          }
        }
      }
    }
  }
  .table /deep/ .ivu-table th:first-child {
    border-top-left-radius: 10px;
    background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
    color: #fff;
  }
}
</style>
